<template>
    <div>
      <div class="page-title">
        <h4> Creaza rol </h4>
      </div>
      <div class="row">
        <div class=" col-12">
          <div class="form-group single-input">
            <input type="text" v-model="new_role" placeholder="Completeaza rol...">
            <button class="template-save-btn" @click.prevent='createRole()' :disabled="this.$store.state.loading">
              <i class="fas fa-check"></i>
              {{$t('placeholder.salveaza')}}
            </button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import RoleService from '../../api-services/roles.service.js'
export default {
  name: 'CreateRole',
  data () {
    return {
      new_role: null
    }
  },
  methods: {
    createRole () {
      if (!this.new_role) {
        this.$notify({
          group: 'error',
          type: 'error',
          title: this.$t('errors.errorTitle'),
          text: this.$t('errors.roleEmpty'),
          'animation-type': 'css'
        })
        return false
      }
      let data = {
        role: this.new_role
      }
      RoleService.create(data)
        .then((response) => {
          this.$store.dispatch('hideLoading')
          this.$notify({
            group: 'succes',
            type: 'success',
            // title: 'Added',
            text: this.$t('success.rolAdaugat'),
            'animation-type': 'css'
          })
          // var frm = document.getElementById('test-id')
          // alert(frm.offsetTop)
          window.scrollTo(0, 0)
          this.$router.push({ name: 'roles' })
        })
        .catch((error) => {
          console.log(error)
        })
    }
  },
  mounted () {
    this.$store.dispatch('hideLoading')
  }
}
</script>
